var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tooltip-button",class:_vm.computedClass,style:({top: _vm.top+'px',  left: _vm.left+'px'})},[_c('div',{staticClass:"c-tooltip-button__wrap"},[_c('button',{staticClass:"c-tooltip-button__button",on:{"click":_vm.clickEvent}},[_c('span',{staticClass:"c-tooltip-button__decoration"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }